import { createAction, props } from '@ngrx/store';

const confirmLeaveOffer = createAction(
  '[Professional Item Template Component] Ask for confirmation before leaving offer',
  props<{ id: number; fullname: string }>()
);

export const ProfessionalItemActions = {
  confirmLeaveOffer,
};
